import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

import DetailedSheetDto from '../../dto/detailed-sheets/out/detailed-sheet.dto';
import FindUserDetailedSheetService from '../../services/detailed-sheets/find-user-detailed-sheet.service';

const useFindUserDetailedSheet = (
  options?: Omit<
    UseQueryOptions<DetailedSheetDto, Error>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<DetailedSheetDto, Error> => {
  return useQuery(
    'detailed-sheets/me',
    new FindUserDetailedSheetService().find,
    options,
  );
};

export default useFindUserDetailedSheet;
